export default "__VITE_ASSET__CC3WTxLY__"